<template>
    <div class="application--wrapper__outer">
        <application-header></application-header>
        <div class="application--form__section">
            <div class="section__text">
                <h1 class="heading--lg">Unsolicited Application</h1>
                <p class="paragraph">
                    We always need great people with different skillsets. Feel free to send us an unsolicited
                    application.
                    Bohemia Interactive offices in the Czech Republic, The Netherlands and Thailand are home
                    to more
                    than 300 people of various nationalities. We share one common goal: making great video games.
                </p>
                <div class="divider"></div>
                <h2 class="heading--md">Application</h2>
                <span class="floating-text">Please choose your office, expertise and category below</span>
                <application-form>
                </application-form>
            </div>
        </div>
    </div>
</template>

<script>
  import ApplicationHeader from "../components/applicationPageComponents/ApplicationHeader";
  import ApplicationForm from "../components/applicationPageComponents/ApplicationForm";

  export default {
    components: {
      ApplicationForm,
      ApplicationHeader
    },
    name: "ApplicationPage"
  };
</script>

<style scoped lang="scss">

    .application--form__section {
        background-color: white;
    }

    .section__text {
        padding: 4em;
        padding-left: 9em;

        p {
            max-width: 70%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/ApplicationPage.vue